const formatBankAccount = (account: string, type: string) =>
  `${type || ""} ${account ? `(xxxx - ${account})` : ""}`;
export default formatBankAccount;
